module.exports = __webpack_public_path__ + "static/media/carlos-perez.133209d6.jpg";